module.exports = __webpack_public_path__ + "media/images/login_as-a960a89d54981e7c260785b15eb84820.gif";